import apiClient from './config';
import { Instructor, EntityUsage, ReassignResponse, DeleteResponse } from "../../types/index"



// Servicios para obtener, crear, actualizar y eliminar instructores
export const fetchInstructores = async (): Promise<Instructor[]> => {
    const response = await apiClient.get('/instructores');
    return response.data;
};

// Funcion para crear instructores llamando al endpoint POST /instructores
export const createInstructor = async (instructor: Instructor) => {
    const response = await apiClient.post('/instructores', instructor);
    return response.data;
};



// Funcion para actualizar instructores llamando al endpoint PUT /Instructor/:instructorId
export const updateIntructor = async (instructor: Instructor): Promise<Instructor> => {
    const response = await apiClient.put(`/instructores/${instructor._id}`, instructor);
    return response.data;
};



// B1 — cuántas clases, plantillas, etc. usan este instructor. Se consulta antes
// de eliminar para saber si toca borrar, archivar o reasignar.
export const fetchInstructorUsage = async (instructorId: string): Promise<EntityUsage> => {
    const response = await apiClient.get(`/instructores/${instructorId}/usage`);
    return response.data;
};

// B1 — mueve las clases futuras y las plantillas de este instructor a otro.
export const reassignInstructor = async (
    instructorId: string,
    targetId: string
): Promise<ReassignResponse> => {
    const response = await apiClient.post(`/instructores/${instructorId}/reassign`, { targetId });
    return response.data;
};

// Funcion para eliminar instructores llamando al endpoint DELETE /instructores/:instructorId
// B1: devuelve `archived` — el backend archiva en vez de borrar cuando quedan
// clases pasadas, y responde 409 si aún hay uso futuro.
export const deleteInstructor = async (instructorId: string): Promise<DeleteResponse> => {
    const response = await apiClient.delete(`/instructores/${instructorId}`);
    return response.data;
};

